<template>
  <div class="animated fadeIn">

    <server-side-paginated-table
            :fields="table_settings.fields"
            :api_url="table_settings.api_url"
            :delete_url="table_settings.delete_url"
            ref="displayTable"
            :top_right_btn_redirect="false"
    />

  </div>
</template>
<script>
    import {bus} from '@/main.js';
    import SwalMixin from '@/views/mixins/Swal.js'
    import { server_details } from "@/config";
    import ServerSidePaginatedTable from './ServerSidePaginatedTable.vue';
    export default {
      mixins:[SwalMixin],
      components: {ServerSidePaginatedTable},
      data: () => {
          return {
            table_settings:{
              api_url:'site-timelog-logs/recent',
              delete_url:'roles/delete',
              fields:[
                {key: 'id_number', label:'ID Number'},
                {key: 'am_in', label:'AM IN'},
                {key: 'am_out', label:'AM OUT'},
                {key: 'pm_in', label:'PM IN'},
                {key: 'pm_out', label:'PM OUT'},
                {key: 'ot_in', label:'OT IN'},
                {key: 'ot_out', label:'OT OUT'},
              ]
            },
            form:{
              date_from:'',
              date_to:''
            },
            projects:[]
          }
      },
      created(){
      },
      methods: {
        exportJson(){
          event.preventDefault()
          this.swalConfirmSubmit((data)=>{
            if (data.value) {
              this.is_saving=true;
              this.axios.post('export/logs',this.form).then(response => {
                this.swalTransactionCompleted();
                window.location.href = server_details.BASE_SERVER_URL+"/export-logs/"+response.data;
              }).catch(error => {
                console.log(error)
                this.swal_transaction_error_data.text = error.response.data;
                this.swalRequestError();
              });
            }
          });
        },
      }
    }
</script>
